import React from 'react'
import styles from './styles.module.css'

/** Shared three-line placeholder used by Agent history and comment threads. */
export const MessageSkeleton: React.FC<{ className?: string }> = ({ className }) => (
  <div className={className} aria-hidden="true">
    <div className={styles.line} />
    <div className={`${styles.line} ${styles.medium}`} />
    <div className={`${styles.line} ${styles.short}`} />
  </div>
)
